import React, {useState, useEffect} from 'react';
import { getForgotPasswordURL } from '../../Services/getForgotPasswordURL'
import { translations } from '../Text/translations';

  const NetflixActivated = ({ currentLang, nickname, mobilenowid, emailnowid, fsa, fsaType }) => {
  const [netflixForgotLink, setNetflixForgotLink] = useState('');

  useEffect(() => {
    Promise.all([
      getForgotPasswordURL('NETFLIX')
    ]).then(([forgotPasswordResponse]) => {
      setNetflixForgotLink(forgotPasswordResponse.url);
    });
  }, [fsaType, fsa]);
  const handleLogonButtonClick = () => {
    window.location.href = netflixForgotLink;
  };
  return (
    <>
      <div className="message">
        <h4>{translations[currentLang].netflixSubjectGreeting}{nickname || mobilenowid || emailnowid}{translations[currentLang].netflixSubjectGreeting2}</h4>
        <p>{translations[currentLang].netflixActivated}</p>
        <p>{translations[currentLang].netflixActivateNowRemark}</p>
      </div>
    <div className="cta-buttons">
      <button className="btn outline" onClick={handleLogonButtonClick}>
        {translations[currentLang].forgotNetflixLogin}
      </button>
    </div>
    </>
  );
};

export default NetflixActivated;